import styled from 'styled-components';
import { forTablet } from '@westwing/ui-kit/breakPoints';
import { TOP_INSET } from './Steps.styles';
import Heading from '@ids/components/Typography/Heading';
import Center from '@ids/components/Layout/Center';

export const HowItWorksSection = styled.section``;

export const Title = styled(Heading)`
    text-align: center;
    margin-bottom: calc(30px + ${TOP_INSET});

    ${forTablet`
        margin-bottom: 30px;
    `}
`;

export const ButtonWrapper = styled(Center)`
    padding: 0 5vw;
`;
